// export const IP = "https://smooth-house-production.up.railway.app/api"
export const IP = 'https://api.warrantyninja.com/api' //common part of the api used to call all the data in the project 

// secure token
export const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZXN1bHRzIjpbeyJ1c2VyX2lkIjo0LCJ1c2VyX2ZpcnN0bmFtZSI6IkRpZ3ZpamF5IiwidXNlcl9sYXN0bmFtZSI6IkphZGhhdiIsInVzZXJfbmFtZSI6ImRpZ3lhMjgiLCJ1c2VyX2VtYWlsIjoiZGlneWFAZ21haWwuY29tIiwidXNlcl9hZGRyZXNzIjoiNDEgdyAxN3RoIiwidXNlcl9waG4iOiI4MzI5NTU2MTMwIn1dLCJpYXQiOjE2MjA3MTMzMzksImV4cCI6MTYyMDcxNjkzOX0.Te_SgLn17qrTZdNJdGlNt8L2sLoXqVy7CA-b8BS_nag";
